export enum infoBlockModes {
  VIEW = 'view',
  EDIT = 'edit',
  CREATE ='create',
}
